import { render, staticRenderFns } from "./ServiceFormEditView.vue?vue&type=template&id=5210770c&scoped=true&"
import script from "./ServiceFormEditView.vue?vue&type=script&lang=js&"
export * from "./ServiceFormEditView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormEditView.vue?vue&type=style&index=0&id=5210770c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210770c",
  null
  
)

export default component.exports